<template>
  <div class="">
    <Card>
      <Button type="primary" icon="md-add" @click="add" style="margin-bottom: 20px">新增反馈</Button>
      <Table :columns="column" :data="data">
        <template slot-scope="{ row }" slot="action">
          <div>
            <a class="action" @click="showDetail(row)">查看详情</a>
          </div>
        </template>
        <template slot-scope="{ row }" slot="content">
          <div style="display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; text-overflow: ellipsis">
            {{ row.content }}
          </div>
        </template>
        <template slot-scope="{ row }" slot="time">
          <div>{{ row.createdAt | formatTime }}</div>
        </template>
      </Table>
      <Page v-if="pagination.total" :total="pagination.total" @on-change="changePage" show-elevator></Page>
      <Modal v-model="showModal" title="反馈">
        <Form :model="form" :label-width="80" ref="feedback" :rules="ruleFeedback">
          <FormItem label="反馈类型:" prop="feedbackType">
            <Select v-model="form.feedbackType">
              <Option v-for="item in feedbackTypes" :value="item.value" :key="item.value">{{ item.value }}</Option>
            </Select>
          </FormItem>
          <FormItem label="内容描述:" prop="content">
            <Input :rows="6" placeholder="请简要描述你的问题..." maxlength="20000" ref="editor" v-model="form.content" type="textarea"></Input>
          </FormItem>
        </Form>
        <template #footer>
          <Button @click="cancel">取消</Button>
          <Button type="error" @click="confirm">确认</Button>
        </template>
      </Modal>
      <Modal v-model="detailModal" title="反馈详情">
        <Form :model="item" :label-width="80">
          <FormItem label="功能模块:">
            <span>{{ item.feedbackType }}</span>
          </FormItem>
          <FormItem label="反馈内容:">
            <span style="white-space: pre-wrap">{{ item.content }}</span>
          </FormItem>
          <FormItem label="提交时间:">
            <span>{{ item.createdAt | formatTime }}</span>
          </FormItem>
          <FormItem v-if="item.status === 2" label="回复内容:">
            <span style="word-break: break-all;">{{ item.reply.content }}</span>
          </FormItem>
          <FormItem v-if="item.status === 2" label="回复时间:">
            <span>{{ item.reply.replyTime | formatTime }}</span>
          </FormItem>
          <FormItem label="状态:">
            <span>{{ item.statusStr }}</span>
          </FormItem>
        </Form>
      </Modal>
    </Card>
  </div>
</template>

<script>
import editor from '@/components/editor/editor';
export default {
  components: {
    editor
  },
  data() {
    return {
      form: {},
      showModal: false,
      detailModal: false,
      item: {
        reply: {
          content: undefined,
          replyTime: undefined
        }
      },
      pagination: {},
      column: [
        {
          title: '序号',
          type: 'index',
          width: 80
        },
        {
          title: '功能模块',
          key: 'feedbackType',
          width: 100
        },
        {
          title: '反馈内容',
          slot: 'content',
          width: 400
        },
        {
          title: '提交时间',
          slot: 'time',
          width: 160
        },
        {
          title: '状态',
          key: 'statusStr',
          width: 100
        },
        {
          title: '操作',
          slot: 'action',
          align: 'center'
        }
      ],
      page: 1,
      data: [],
      feedbackTypes: [],
      ruleFeedback: {
        content: [{ required: true, message: '内容描述不能为空', trigger: 'blur' }],
        feedbackType: [{ required: true, message: '反馈类型不能为空', trigger: 'blur' }]
      }
    };
  },
  mounted() {
    this.getList();
    this.getDictType('feedback_type');
  },
  methods: {
    add() {
      this.showModal = true;
      this.form = {
        feedbackType: '',
        content: ''
      };
    },
    showDetail(item) {
      this.item = item;
      this.detailModal = true;
    },
    getDictType(dictType) {
      this.$axios
        .request({
          url: 'front/v1/common/dict-data',
          method: 'get',
          params: {
            dictType: dictType,
            dictLabel: '企业PC端'
          }
        })
        .then(res => {
          this.feedbackTypes = res.data;
        });
    },
    changePage(page) {
      this.page = page;
      this.getList();
    },
    getList() {
      this.$axios
        .request({
          url: 'front/v1/feedback/own',
          method: 'get',
          params: {
            idOrder: 'desc',
            pageIndex: this.page,
            userType: '企业PC端'
          }
        })
        .then(res => {
          this.data = res.data.list;
          this.pagination = {
            total: res.data.count,
            pageIndex: res.data.pageIndex,
            pageSize: res.data.pageSize
          };
        });
    },
    getText(html) {
      this.form.content = html;
    },
    cancle() {
      this.form = {};
    },
    confirm() {
      this.$refs['feedback'].validate(ok => {
        console.log(ok);
        if (ok) {
          this.form.userType = '企业PC端';
          this.$axios
            .request({
              url: 'front/v1/feedback',
              method: 'post',
              data: this.form
            })
            .then(res => {
              this.$Message.success('提交成功');
              this.form = {};
              this.showModal = false;
              this.getList();
            });
        }
      });
    },
    cancel() {
      this.showModal = false;
      this.$refs['feedback'].resetFields();
    }
  }
};
</script>

<style lang="less" scoped>
.yijian {
  background: #fff;
  padding: 60px;
  .container {
    width: 600px;
    margin: 0 auto;
    .title {
      font-size: 18px;
      color: rgba(54, 62, 79, 1);
      margin-bottom: 18px;
    }
    .btns {
      float: right;
      display: flex;
      > div {
        width: 88px;
        height: 30px;
        line-height: 30px;
        text-align: center;
      }
      > div:first-child {
        border: 1px solid #d6000f;
        color: #d6000f;
        margin-right: 20px;
      }
      > div:last-child {
        background: #d6000f;
        color: #fff;
      }
    }
  }
}

::v-deep .ivu-modal-body {
  max-height: 70vh;
  overflow-y: auto;
}
</style>
